export default __webpack_public_path__ + "static/media/oltiva_logo.6407ff1c.svg";